import { GemecoState } from "@gemeco/Store/GemecoState";
import { ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import {
    chain,
    GetCurrentAccount,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    UpdateAccountApiParameter,
    AccountModel,
    { account: AccountModel; getState: () => GemecoState }
>;

export const addDefaultToOneTimeShipTo: HandlerType = props => {
    const account = props.getState().pages.accountSettings.editingAccount;
    const defaultToOneTimeShipTo = props.getState().defaultOneTimeShipTo?.isDefaultToOneTimeShipToEnabled
        ? "true"
        : "false";

    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }
    props.account = {
        ...props.account,
        properties: {
            ...props.account.properties,
            defaultToOneTimeShipTo,
        },
    };
};

addToChainAfter(chain, GetCurrentAccount, addDefaultToOneTimeShipTo);